export default () => ({
    status: 'authenticating', // 'authenticated', 'not-authenticated', 'authenticating'
    user: null,
    token: null
})